import BootstrapDialog from 'bootstrap4-dialog/dist/js/bootstrap-dialog.js';

globalThis.BootstrapDialog = BootstrapDialog;
export default BootstrapDialog;